import React from 'react';

/**
 * AttendanceStats Component
 * Displays attendance statistics in card format
 */
const AttendanceStats = ({ stats, loading = false }) => {
  if (loading) {
    return (
      <div className="attendance-stats">
        <div className="stats-grid">
          {[...Array(7)].map((_, index) => (
            <div key={index} className="stat-card loading">
              <div className="stat-number skeleton"></div>
              <div className="stat-label skeleton"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Format hours display
  const formatHours = (hours) => {
    if (!hours || hours === 0) return '0 hours';
    
    if (hours < 1) {
      const minutes = Math.round(hours * 60);
      return `${minutes} min`;
    }
    
    const wholeHours = Math.floor(hours);
    const minutes = Math.round((hours - wholeHours) * 60);
    
    if (minutes === 0) {
      return `${wholeHours} ${wholeHours === 1 ? 'hour' : 'hours'}`;
    } else {
      return `${wholeHours}h ${minutes}m`;
    }
  };

  const statCards = [
    {
      key: 'total',
      label: 'Total Records',
      value: stats.totalRecords || 0,
      color: '#1890ff',
      icon: '📊'
    },
    {
      key: 'approved',
      label: 'Approved',
      value: stats.approvedRecords || 0,
      color: '#52c41a',
      icon: '✅'
    },
    {
      key: 'pending',
      label: 'Pending',
      value: stats.pendingRecords || 0,
      color: '#faad14',
      icon: '⏳'
    },
    {
      key: 'rejected',
      label: 'Rejected',
      value: stats.rejectedRecords || 0,
      color: '#ff4d4f',
      icon: '❌'
    },
    {
      key: 'employees',
      label: 'Unique Employees',
      value: stats.uniqueEmployees || 0,
      color: '#722ed1',
      icon: '👥'
    },
    {
      key: 'hours',
      label: 'Total Hours Worked',
      value: formatHours(stats.totalHoursWorked || 0),
      color: '#f759ab',
      icon: '🕒'
    },
    {
      key: 'validation',
      label: 'Avg Validation Score',
      value: `${stats.averageValidationScore || 0}%`,
      color: '#13c2c2',
      icon: '🎯'
    }
  ];


  return (
    <div className="attendance-stats">
      {/* Main Statistics */}
      <div className="stats-section">
        <div className="stats-grid">
          {statCards.map((stat) => (
            <div key={stat.key} className="stat-card">
              <div className="stat-icon" style={{ color: stat.color }}>
                {stat.icon}
              </div>
              <div className="stat-content">
                <div className="stat-number" style={{ color: stat.color }}>
                  {stat.value}
                </div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* No Data Message */}
      {stats.totalRecords === 0 && (
        <div className="no-stats-message">
          <div className="no-stats-icon">📊</div>
          <h3>No Attendance Data</h3>
          <p>No attendance records found for the selected filters and date range.</p>
        </div>
      )}
    </div>
  );
};

export default AttendanceStats;
